export default __webpack_public_path__ + "static/media/3-desk.f2278af8.jpg";